import { useMemo } from 'react';

interface TocEntry {
  id: string;
  text: string;
  level: number;
}

function extractToc(content: string): TocEntry[] {
  const entries: TocEntry[] = [];
  const lines = content.split('\n');
  for (const line of lines) {
    const match = line.match(/^(#{1,4})\s+(.+)$/);
    if (match) {
      const level = match[1].length;
      const text = match[2].replace(/\*\*/g, '').trim();
      const id = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
      entries.push({ id, text, level });
    }
  }
  return entries;
}

export function TableOfContents({ content }: { content: string }) {
  const toc = useMemo(() => extractToc(content), [content]);

  if (toc.length < 3) return null;

  function handleClick(e: React.MouseEvent, id: string) {
    // <main> is a custom overflow-y:auto scroll container, so native
    // href="#anchor" scrolls the window (no-op here). Use scrollIntoView
    // instead — it targets the nearest scrolling ancestor, which is <main>.
    const target = document.getElementById(id);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  return (
    <nav className="docs-toc">
      <div className="docs-toc-inner">
        <p className="docs-toc-title">On this page</p>
        <ul className="docs-toc-list">
          {toc.map((entry) => (
            <li key={entry.id}>
              <a
                href={`#${entry.id}`}
                className="docs-toc-link"
                data-level={entry.level}
                onClick={(e) => handleClick(e, entry.id)}
              >
                {entry.text}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
